import Swiper, { Navigation } from 'swiper';
import 'swiper/css';

/**
 * Related articles slider on single blog posts (views/components/related-posts-slider.twig).
 * 1 / 2 / 3 cards per view; the prev/next arrows sit left + right of the track and are
 * vertically centered on the card images via the --arrow-top custom property.
 */
export default function () {
    document.querySelectorAll('.js-related-posts-slider').forEach((block) => {
        const container = block.querySelector('.js-related-posts-swiper');
        if (!container) {
            return;
        }

        const setArrowTop = () => {
            const image = container.querySelector('.blog-card__image-wrapper');
            if (image) {
                block.style.setProperty('--arrow-top', `${image.offsetHeight / 2}px`);
            }
        };

        new Swiper(container, {
            modules: [Navigation],
            slidesPerView: 1.08,
            spaceBetween: 16,
            breakpoints: {
                768: { slidesPerView: 2, spaceBetween: 20 },
                1024: { slidesPerView: 3, spaceBetween: 24 },
            },
            navigation: {
                prevEl: block.querySelector('.js-related-posts-prev'),
                nextEl: block.querySelector('.js-related-posts-next'),
            },
            on: {
                init: setArrowTop,
                resize: setArrowTop,
            },
        });
    });
}
